import {useCallback, useEffect, useState} from "react";

// ovaj hook traži da se dto error UVIJEK prije počisti jer npr
export const useErrorMessage = (
    initialValue: string | JSX.Element | undefined,
) => {
    const [localErrorMessage, setLocalErrorMessage] = useState<
        string | undefined
    >(initialValue?.toString());

    const clearLocalErrorMessage = useCallback(() => {
        setLocalErrorMessage(undefined);
    }, [setLocalErrorMessage]);

    useEffect(() => {
        setLocalErrorMessage(initialValue?.toString());
    }, [initialValue]);

    return {localErrorMessage, clearLocalErrorMessage};
};
